import { QueryClient } from "@tanstack/react-query";
import { CRESO_ARN } from "../constants";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: { refetchOnWindowFocus: false, retry: false },
  },
});

export * from "./string";
export * from "./investor";
export * from "./currency";
export * from "./folio";
export * from "./transaction";
export * from "./client";
export * from "./notification";
export * from "./funds";
export * from "./financial";
export * from "./feature";
export * from "./phone-display";
export * from "./book-demo";
export * from "./bank-service-capabilities";
export * from "./upi-intent";
export * from "./product-breakdown";
export * from "./goal";
export * from "./family";
export * from "./resource";
export * from "./kyc";
export * from "./birthday";
export * from "./campaign";

const AMC_LOGO_BUCKETS = {
  production: "prod-creso-news-media",
  staging: "stg-creso-news-media",
  development: "nonprod-creso-news-media",
} as const;

export const getAMCLogoURL = (
  id?: string | null,
  environment: keyof typeof AMC_LOGO_BUCKETS = "development"
) =>
  `https://${AMC_LOGO_BUCKETS[environment]}.s3.amazonaws.com/media/amc/logos/${id}.png`;

export const getCreativesURL = (dev = false) => {
  if (dev) return "https://non-prod.creso.in/media/creatives/today.webp";
  return `${window.location.origin}/media/creatives/today.webp`;
};

export const sleep = (ms: number) =>
  new Promise((resolve) => {
    setTimeout(resolve, ms);
  });

export function getPromiseWithResolvers<T>() {
  let resolve: (val: T) => void;
  let reject: (error?: Error) => void;
  const promise = new Promise<T>((res, rej) => {
    resolve = res;
    reject = rej;
  });
  // @ts-expect-error skip
  return { promise, reject, resolve };
}

export function getFinancialYear(date: Date) {
  const currentYear = date.getFullYear();
  const currentMonth = date.getMonth();
  if (currentMonth >= 4) {
    return currentYear;
  }
  return currentYear - 1;
}

export function isCresoARN(arn: string) {
  return arn === CRESO_ARN;
}
